export default __webpack_public_path__ + "static/media/search.08a74cd1.svg";